import { useEffect, useState } from "react";
import "../App.css";

const BASE_URL = "https://ca2-team11-server-0rto.onrender.com";

const MATERIAL_CO2_FACTOR = {
  plastic: 1.5,
  paper: 1.0,
  glass: 2.0,
  metal: 3.0,
};

const WEEKLY_GOAL = 35;

export default function Home() {
  const [totalItems, setTotalItems] = useState(0);
  const [materialCount, setMaterialCount] = useState(0);
  const [co2Saved, setCo2Saved] = useState(0);
  const [topMaterial, setTopMaterial] = useState("—");

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await fetch(`${BASE_URL}/allrecyclable`);
      const data = await res.json();

      if (!Array.isArray(data)) return;

      let items = 0;
      let co2 = 0;
      const materialSet = new Set();
      const materialTotals = {};

      data.forEach((item) => {
        const qty = Number(item.quantity) || 0;
        const material = (item.material || "").toLowerCase();

        items += qty;

        if (material) {
          materialSet.add(material);
          materialTotals[material] =
            (materialTotals[material] || 0) + qty;
        }

        const factor = MATERIAL_CO2_FACTOR[material] || 1;
        co2 += qty * factor;
      });

      // Find top material
      let top = "—";
      let max = 0;
      Object.keys(materialTotals).forEach((mat) => {
        if (materialTotals[mat] > max) {
          max = materialTotals[mat];
          top = mat;
        }
      });

      setTotalItems(items);
      setMaterialCount(materialSet.size);
      setCo2Saved(co2.toFixed(1));
      setTopMaterial(top.charAt(0).toUpperCase() + top.slice(1));
    } catch (err) {
      console.error("Failed to fetch homepage stats", err);
    }
  };

  return (
    <>
      {/* HERO SECTION */}
      <div className="hero-banner">
        <div className="hero-overlay">
          <h1>
            Small Acts, <span className="highlight">Big Impact</span>
          </h1>
          <p>
            Join the movement to make the world a cleaner place, one item at a
            time.
          </p>
          <div className="hero-btns">
            <button 
              className="btn-primary" 
              onClick={() => window.open("https://recycle.gov.sg/", "_blank", "noopener,noreferrer")}
            >
              Learn More
            </button>          
          </div>
        </div>
      </div>

      {/* STATS BAR */}
      <div className="stats-bar">
        <div className="stat-item">
          <h2>{totalItems}</h2>
          <p>Items Saved</p>
        </div>

        <div className="stat-divider"></div>

        <div className="stat-item">
          <h2>{materialCount}</h2>
          <p>Materials Tracked</p>
        </div>

        <div className="stat-divider"></div>

        <div className="stat-item">
          <h2>{co2Saved}kg</h2>
          <p>CO₂ Saved</p>
        </div>
      </div>

      {/* BOTTOM FEATURE CARDS */}
      <div className="feature-grid">
        {/* LEFT – WEEKLY GOAL */}
        <div className="glass-card">
          <div className="card-icon">🎯</div>
          <h3>Weekly Goal</h3>
          <p>
            Goal: <strong>{WEEKLY_GOAL}</strong> items recycled
          </p>
          <p>
            Current progress: <strong>{totalItems}</strong> items
          </p>
          {totalItems >= WEEKLY_GOAL && (
            <p style={{ marginTop: 12, fontWeight: 600, color: "#2d6a4f" }}>
              🎉 Goal achieved! Keep up the great work.
            </p>
          )}
        </div>

        {/* MIDDLE – TOP MATERIAL */}
        <div className="glass-card">
          <div className="card-icon">🏆</div>
          <h3>Top Material Recycled</h3>
          <p>
            The material you’ve recycled the most so far is:
          </p>
          <p style={{ fontSize: "1.4rem", fontWeight: 700, marginTop: 10 }}>
            {topMaterial}
          </p>
        </div>

        {/* RIGHT – RECYCLING TIP */}
        <div className="glass-card">
          <div className="card-icon">💡</div>
          <h3>Recycling Tip</h3>
          <p>
            Always rinse food containers before recycling. Leftover residue can
            contaminate an entire batch of recyclables.
          </p>
        </div>
      </div>
    </>
  );
}
